var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconAuthy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_867_8092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 15.1502C30 23.4351 23.2845 30.1504 14.9996 30.1504C6.71531 30.1504 0 23.4351 0 15.1502C0 6.86582 6.71531 0.150391 14.9996 0.150391C23.2845 0.150391 30 6.86582 30 15.1502Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7137 11.9734L17.3103 15.5687C17.8295 16.0885 18.6724 16.0885 19.1928 15.5687C19.7121 15.049 19.7133 14.2067 19.1928 13.6869L15.596 10.0902C13.0224 7.51603 8.86299 7.47455 6.23483 9.95939C6.21029 9.97977 6.18664 10.0012 6.16393 10.0236C6.15245 10.0351 6.14307 10.0473 6.1317 10.0576C6.11998 10.0688 6.10803 10.0789 6.0969 10.0902C6.07416 10.1128 6.05342 10.1366 6.03362 10.1601C3.54748 12.7895 3.59026 16.949 6.16405 19.5231L9.76077 23.1191C10.2811 23.6386 11.1228 23.6386 11.643 23.1191C12.1636 22.5991 12.1636 21.7558 11.6443 21.237L8.04748 17.6404C6.47741 16.071 6.46686 13.5238 8.01491 11.9408C9.59764 10.3927 12.1434 10.404 13.7137 11.9735V11.9734ZM18.3558 7.18357C17.836 7.70353 17.836 8.54564 18.3572 9.06548L21.9526 12.6623C23.5217 14.2317 23.5319 16.7785 21.984 18.3619C20.4008 19.9087 17.8558 19.8984 16.286 18.3288L12.6893 14.7324C12.1692 14.2125 11.326 14.2125 10.8065 14.7324C10.2859 15.2519 10.2859 16.0967 10.8065 16.6151L14.4021 20.212C16.9765 22.786 21.1355 22.8279 23.7641 20.3428C23.7885 20.3212 23.8114 20.3012 23.8356 20.2785C23.8466 20.2673 23.8569 20.256 23.8676 20.2445C23.8793 20.2333 23.8907 20.223 23.9016 20.2106C23.9246 20.1892 23.9443 20.1656 23.9648 20.141C26.451 17.5127 26.4094 13.3545 23.8357 10.779L20.239 7.18345C19.7191 6.66279 18.8751 6.66279 18.3558 7.18357Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_867_8092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.150391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconAuthy);
export default __webpack_public_path__ + "static/media/TH-Icon-Authy.33f8f1327a9e4fc74662ef1f896e2624.svg";
export { ForwardRef as ReactComponent };